'use strict';

module.exports = bail;

function bail(err) {
  if (err) {
    throw err;
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/bail/index.js
// module id = 173
// module chunks = 147254134005266 182246549230831 215303740077764